export const AUTHENTICATION_CONSTANTS = {

    SET_USER_TOKEN: "SET_USER_TOKEN",
    SET_USER_TOKEN_LOCAL: "SET_USER_TOKEN_LOCAL",
    SET_USER_LOGOUT: "SET_USER_LOGOUT",
    NAVIGATE_TO_HOMEPAGE: "NAVIGATE_TO_HOMEPAGE",
    SET_USER_WALLETS: "SET_USER_WALLETS",
    SET_NETWORK_SETTINGS: "SET_NETWORK_SETTINGS",
    SET_CURRENCIES: "SET_CURRENCIES",
    SET_ACTIVE_WALLET: "SET_ACTIVE_WALLET",
    SET_WALLET_BALANCE: "SET_WALLET_BALANCE",
    SET_WALLET_PERCENTAGE: "SET_WALLET_PERCENTAGE",
    SET_ACTIVE_NETWORK: "SET_ACTIVE_NETWORK",
    SET_HIDE_ZERO_BALANCE: "SET_HIDE_ZERO_BALANCE",
    SET_FIAT_RATES: "SET_FIAT_RATES",
    SET_IGNORED_USERS: "SET_IGNORED_USERS",
    SET_LAST_CHAT_LANGUAGE: "SET_LAST_CHAT_LANGUAGE",
    SET_DISPLAY_FIAT_IN_CRYPTO: "SET_DISPLAY_FIAT_IN_CRYPTO",
    SET_SELECTED_FIAT: "SET_SELECTED_FIAT",
    SET_STREAM_ID: "SET_STREAM_ID",
};
